<div class="hub-wrapper">
  <div class="hub-header">
    <h1 class="hub-title">INFORMATION HUB</h1>
  </div>
  <div class="hub-body">
    <nav class="hub-sidebar">
      <a routerLink="notifications" routerLinkActive="active-link" class="hub-nav-item">
        <mat-icon>notifications</mat-icon>
        <span>NOTIFICATIONS</span>
      </a>
      <a routerLink="meeting-notes" routerLinkActive="active-link" class="hub-nav-item">
        <mat-icon>description</mat-icon>
        <span>MEETING<br>NOTES</span>
      </a>
      @if (canManage) {
        <a routerLink="administration" routerLinkActive="active-link" class="hub-nav-item">
          <mat-icon>settings</mat-icon>
          <span>ADMINISTRATION</span>
        </a>
      }
    </nav>

    <div class="hub-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
